import React from "react";

const BillAddressSeacrhFake = () => {
  return (
    <div className="container">
      <div className="bill-address-fake">
        <div className="bill-address-fake--box">
          <div className="skeleton bill-address-fake--address" />
        </div>
        <div className="bill-address-fake--buttons">
          <div className="skeleton bill-address-fake--button" />
          <div className="skeleton bill-address-fake--button" />
        </div>
      </div>
      <style jsx>{`
        .bill-address-fake {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
          width: 100%;
          &--box {
            border: 1px solid #dddddd;
            padding: 1rem;
          }
          &--address {
            height: 1rem;
            width: 33%;
          }
          &--buttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin-top: 2rem;
          }
          &--button {
            height: 45px;
            width: 100%;
          }
        }
        @media (min-width: 768px) {
          .bill-address-fake {
            width: 70%;
            &--buttons {
              width: 40%;
              flex-direction: row;
            }
          }
        }
      `}</style>
    </div>
  );
};

export default BillAddressSeacrhFake;
